import React from 'react';
import { useTranslation } from 'contexts/Safra/TranslationContext';
import { SelectorWrapper, RadioLabel, RadioInput, ErrorMessage } from './styles';

export default function DocumentTypeSelector({ name, value, onChange, error }) {
  const { t } = useTranslation();
  const options = [
    { value: 'CPF', label: 'CPF' },
    { value: 'Passaporte', label: t('safra.passenger_data.form.document_types.passport') },
  ];

  return (
    <div>
      <SelectorWrapper>
        {options.map((opt) => (
          <RadioLabel key={opt.value}>
            <RadioInput
              type="radio"
              name={name}
              value={opt.value}
              checked={value === opt.value}
              onChange={onChange}
            />
            {opt.label}
          </RadioLabel>
        ))}
      </SelectorWrapper>
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </div>
  );
}
